import { getString } from "../common/common";

export const STARTING_FROM = "STARTING_FROM";
export const GOING_TO = "GOING_TO";
export const JOURNEY_DATE = "JOURNEY_DATE";
export const RETURN_DATE = "RETURN_DATE";
export const OPTIONAL = "OPTIONAL";
export const SINGLE_LADY = "SINGLE_LADY";
export const MODIFY = "MODIFY";
export const CHO0SE_DATE = "CHO0SE_DATE";

export const translations = {
  en: {
    [STARTING_FROM]: "Starting From",
    [GOING_TO]: "Going To",
    [JOURNEY_DATE]: "Journey date",
    [RETURN_DATE]: "Return date",
    [SINGLE_LADY]: "Single Lady",
    [MODIFY]: "MODIFY",
    [CHO0SE_DATE]: "Choose date",
    [OPTIONAL]: "optional",
  },
  kn: {
    [STARTING_FROM]: "ಇಂದ ಪ್ರಾರಂಭವಾಗುತ್ತಿದೆ",
    [GOING_TO]: "ಎಲ್ಲಿಗೆ",
    [JOURNEY_DATE]: "ಪ್ರಯಾಣದ ದಿನಾಂಕ",
    [RETURN_DATE]: "ಆಗಮನ ದಿನಾಂಕ",
    [SINGLE_LADY]: "ಒಂಟಿ ಮಹಿಳೆ",
    [MODIFY]: "ಮಾರ್ಪಡಿಸಿ",
    [CHO0SE_DATE]: "ದಿನಾಂಕವನ್ನು ಆರಿಸಿ",
    [OPTIONAL]: "ಐಚ್ಛಿಕ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
